var map = {
	"./Points_being_collected.gif": 377,
	"./Points_being_collected_pld.gif": 534,
	"./background.gif": 167,
	"./misile.gif": 535,
	"./movingFullStone.gif": 378,
	"./stamp_2x.gif": 379,
	"./stamp_5x.gif": 380,
	"./war_day_bg.gif": 536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 620;